@if (componentData.data$ | async; as component) {
  <div
    class="teaser-wrapper"
    [ngClass]="{
      'background--dark': component.backgroundColor === backgroundColor.GREY,
      'pb-0': component.removeBottomSpacing | safeCheck,
    }"
  >
    @if (component.title) {
      <div class="container">
        <div class="row">
          <div class="col col-lg-12">
            <h2 class="heading">{{ component.title }}</h2>
          </div>
        </div>
      </div>
    }
    <div class="container">
      <div class="row">
        @if (teasers$ | async; as teasers) {
          @for (teaser of teasers; track teaser) {
            @if (component.shape === shape.SQUARE) {
              <boels-teaser-square
                [teaserComponentData]="teaser"
                class="col col-lg-3 col-md-6 col-12"
              ></boels-teaser-square>
            } @else {
              <boels-teaser-rectangle
                [teaserComponentData]="teaser"
                class="col col-lg-3 col-md-6 col-sm-12"
              ></boels-teaser-rectangle>
            }
          }
        }
      </div>
    </div>
  </div>
}
